import { tutorChatTypes } from './Constants';

export function setAiChatModal(data) {
	return {
		type: tutorChatTypes.SET_AI_CHAT_DATA,
		payload: { data },
	};
}

export function aiTutorInit(data) {
	return {
		type: tutorChatTypes.AI_CHAT_INIT,
		payload: { data },
	};
}

export function aiTutorInitSuccess() {
	return {
		type: tutorChatTypes.AI_CHAT_INIT_SUCCESS,
	};
}

export function aiTutorInitError() {
	return {
		type: tutorChatTypes.AI_CHAT_INIT_ERROR,
	};
}

export function getAiChatHistory(data) {
	return {
		type: tutorChatTypes.GET_AI_CHAT_HISTORY,
		payload: { data },
	};
}

export function getAiChatHistorySuccess(data) {
	return {
		type: tutorChatTypes.GET_AI_CHAT_HISTORY_SUCCESS,
		payload: { data },
	};
}

export function getAiChatHistoryError() {
	return {
		type: tutorChatTypes.GET_AI_CHAT_HISTORY_ERROR,
	};
}

export function stopAiEventStream(data) {
	return {
		type: tutorChatTypes.STOP_AI_EVENT_STREAM,
		payload: { data },
	};
}

export function eventAiStreamMessage(data) {
	return {
		type: tutorChatTypes.AI_EVENT_STREAM_MESSAGE,
		payload: {
			data,
		},
	};
}

export function aiConversation(data) {
	return {
		type: tutorChatTypes.AI_CONVERSATION,
		payload: { data },
	};
}

export function aiConversationError() {
	return {
		type: tutorChatTypes.AI_CONVERSATION_ERROR,
	};
}

export function aiTutorAnalytics(data) {
	return {
		type: tutorChatTypes.AI_TUTOR_ANALYTICS,
		payload: { data },
	};
}

export function clearAiChatState() {
	return {
		type: tutorChatTypes.CLEAR_AI_CHAT_STATE,
	};
}
